import { useEffect, useState } from 'react';

export function useViewportWidth(): number {
  const [width, setWidth] = useState(() => {
    if (typeof window === 'undefined') return 0;
    return window.visualViewport?.width ?? window.innerWidth;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const update = () => setWidth(window.visualViewport?.width ?? window.innerWidth);
    update();

    window.addEventListener('resize', update);
    window.visualViewport?.addEventListener('resize', update);
    return () => {
      window.removeEventListener('resize', update);
      window.visualViewport?.removeEventListener('resize', update);
    };
  }, []);

  return width;
}
